<template>
	<div class="companySlider">
		<div class="title">关于飞长好</div>
		<div class="slideBox">
			<div class="slideItem">
				关于我们：
				<div class="content">
					杭州飞长好旅游有限公司，是中国创新型旅游平台，致力于打造一个平民化的旅游平台，让旅游不再是高消费的奢侈品，让旅游不再是普通人的渴望不可及，我们要让旅游走进千家万户，让旅游成为每个人的生活方式，让人人都能轻松旅游，让人人都能每月旅游，让一亿家庭玩遍中国，让三千万家庭玩遍世界，以旅游带动经济和各地区特色产品快速流通。
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:{
			type:String | ''
		},
		data() {
			return {
				companyCurrent:'0',
			}
		},
		computed: {
			
		},
		created() {
			
		},
		methods: {
			companySwitchSlide(type){
				if(type == 'prev'){
					this.$refs.companySlide.prev()
				}else{
					this.$refs.companySlide.next()
				}
			},
			companyCurrentClick(index){
				this.current = index;
				this.$refs.companySlide.setActiveItem(index)
			},
			companySlideChange(name){
				this.companyCurrent = name;
			},
		}
	}
</script>
<style lang="scss" scoped>
.companySlider{
	.title{
		width: 100%;
		font-size: 32px;
		color: #333333;
		line-height: 60px;
		text-align: center;
	}
	.line{
		width: 42px;
		height: 4px;
		background: #0A48AD;
		margin: 10px auto 0;
	}
	.label{
		font-size: 14px;
		color: #666666;
		line-height: 16px;
		margin-top: 10px;
		text-align: center;
	}
	.slideNav{
		width: 100%;
		margin-top: 60px;
		height: 32px;
		.navItem{
			font-size: 16px;
			color: #666666;
			line-height: 32px;
			cursor: pointer;
			&.active{
				color: #0A48AD;
			}
		}
		>span{
			display: block;
			margin: 0 10px;
			font-size: 16px;
			color: #666666;
			line-height: 32px;
		}
	}
	.slideBox{
		width: 100%;
		height: 370px;
		background: #F5F5F5;
		margin-top: 20px;
		position: relative;
		.slideItem{
			width: 100%;
			height: 100%;
			padding: 60px;
			box-sizing: border-box;
			font-size: 22px;
			color: #3D3D3D;
			line-height: 36px;
			.content{
				margin-top: 10px;
			}
		}
	}
	
}
</style>


// WEBPACK FOOTER //
// src/components/companySlider.vue